import React, { useState, useRef, useEffect } from "react";
import { LogoutGoogle } from "@utils/defaultImages";
import ButtonLoader from "@components/ui/Loaders/ButtonLoader";
const LogoutDevice = ({ email, onLogout , logoutLoading }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className="relative inline-block text-left font-sans min-h-[43px] flex-1"
      ref={dropdownRef}
    >
      {/* Display Toggle Box */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between bg-white border border-gray-200 rounded-lg px-3 py-1.5 min-h-[43px] shadow-sm hover:bg-gray-50 transition-colors w-full"
      >
        <span className="text-gray-600 text-sm truncate mr-2">{email}</span>
        <div className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded p-1">
          <svg
            className={`w-3 h-3 text-white transform transition-transform ${
              isOpen ? "rotate-180" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 w-[180px] bg-white rounded-2xl shadow-xl border border-gray-100 z-50 overflow-hidden animate-in fade-in zoom-in duration-200">
          <div className="p-4">
            {/* <h3 className="text-gray-800 font-semibold text-sm mb-3">Switch Account</h3>
            <div className="border-t border-gray-100 mb-3"></div> */}

            {/* Logout Button */}
            <button
              onClick={() => {
                setIsOpen(false);
                onLogout();
              }}
              className="w-full flex items-center justify-center gap-2 bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white py-2 px-4 rounded-xl hover:opacity-90 transition-opacity font-medium"
            >
              <div className="bg-white/20 rounded-full p-1">
                <LogoutGoogle />
              </div>
              <span>{logoutLoading ? <ButtonLoader/> :"Log Out"}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogoutDevice;
